export default function ({ store }) {
  // 마지막 동기화 시각. focus가 짧은 간격으로 반복 발생해도
  // 쿨다운(30초) 안에서는 중복 호출하지 않기 위한 기준값.
  let lastSync = 0
  const COOLDOWN = 30000

  const isLoggedIn = () => {
    const mbMngNo = store.getters['session/getMbMngNo']
    return mbMngNo && mbMngNo !== 'undefined' && mbMngNo !== ''
  }

  // force=true: 쿨다운을 무시하고 즉시 동기화 (초기 로드, 로그인/로그아웃 등)
  const sync = (force = false) => {
    if (!isLoggedIn()) { return }
    if (!force && Date.now() - lastSync < COOLDOWN) { return }
    lastSync = Date.now()
    store.dispatch('zzim/fetchZzimList')
  }

  // 초기 로드
  sync(true)

  // 포커스 시 갱신 (쿨다운 적용), 중복 등록 방지
  if (window.__zzimFocusHandler) {
    window.removeEventListener('focus', window.__zzimFocusHandler)
  }
  window.__zzimFocusHandler = () => sync()
  window.addEventListener('focus', window.__zzimFocusHandler)

  // mbMngNo 변경 감지 (로그인/로그아웃) - 쿨다운 무시하고 즉시 반영, 중복 등록 방지
  if (window.__zzimUnwatch) {
    window.__zzimUnwatch()
  }
  window.__zzimUnwatch = store.watch(
    state => state.session.member.mbMngNo,
    (newMbMngNo, oldMbMngNo) => {
      if (newMbMngNo === oldMbMngNo) { return }

      if (isLoggedIn()) {
        // 로그인(또는 계정 전환): 즉시 최신 찜 목록 동기화
        sync(true)
      } else {
        // 로그아웃: sync()는 isLoggedIn() 가드에서 막히므로
        // 찜 목록을 직접 비우고 쿨다운 기준도 초기화한다.
        lastSync = 0
        store.commit('zzim/SET_ZZIM_LIST', [])
      }
    }
  )
}
